module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaWNvbnMvbXN0aWxlLTMxMHgzMTAucG5nIjs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mstile-310x310.png
// module id = CuAn
// module chunks = 0